import axios from "@/api/config_php";

// 通知列表
export const getNotices = param => axios.get(`/amp/api/v1/PlatformUsersNotice/lists`, { params: param });
// 修改已读
export const noticeReaded = param => axios.post(`/amp/api/v1/PlatformUsersNotice/update`, param);
